$(function () {
    if ($('form#EmployeeApplicationForm').length > 0) {

        $("#WithdrawButton").click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("form").valid()) {
                $("#approveModal").modal({
                    'backdrop': 'static'
                });
            }

            return false;
        });

        $(".btnConfirmWithdraw").on('click', function () {
            $("#IsWithdrawSelected").val(true);
            $("form").submit();
        });

        var doesUserExist = $("#EmployeeUserId").val().trim() != "";

        if (doesUserExist && !jsNoEmail) {
            $("#FirstName").prop("readonly", true);
            $("#LastName").prop("readonly", true);
            //$("#Email").prop("readonly", true);
            //$("#IsNoEmailAddress").parent().parent().hide();
            $("#PreferredLanguageCode_en:not(:checked)").prop("disabled", true);
            $("#PreferredLanguageCode_fr:not(:checked)").prop("disabled", true);
        }

        $("#EmailAssociatedFormMessage").hide();

        $("#IamUserExists").hide();
        if (!doesUserExist) {
            $("#Email").change();
        }
        
        // If the user makes any changes and tries to navigate away without submitting,
        // we will show the standard warning message.
        $("form#EmployeeApplicationForm").on("change", "input, select", function (e) {
            if (e.isTrigger) {
                return;
            }
            
            $("form#EmployeeApplicationForm").data("showNavWarning", true);
        });
        
        window.onbeforeunload = function (e) {
            if ($("form#EmployeeApplicationForm").data("showNavWarning")) {
                e.preventDefault();
                return true;
            }
        };

        // Re-init DOB to show years
        var lang = 'en';
        if (window.location.href.includes('/en/')) { lang = 'en' }
        else { lang = 'fr' }

        $('#DateOfBirth').datetimepicker('options', {
            viewMode: 'years',
            format: "YYYY-MM-DD",
            locale: lang + "-ca",
            keepOpen: false,
            defaultDate: false
        });

        // IsNoEmailAddress updates
        $("#IsNoEmailAddress").change(function () {

            if ($("#btnNext").is(":hidden")) {
                //Run this function to hide everything that shouldnt be displayed
                UpdateNoEmailAddressInfo();
            } else {
                InitializeForm();
            };
        });

        function UpdateNoEmailAddressInfo() {
            $("#ConsentFormMessage").hide();
            $("#IamUserExists").hide();
            $("#EmailContainer").hide();

            if ($("#IsNoEmailAddress").is(":checked")) {
                $("#Email").val("");
                $("#Email").change();
                $("#ConsentFormMessage").show();

                SetDisplayhasExistingWEAccount(false);
                SetDisplayIamUserExists(false);
                SetDisplayIamUserExistsHide(false);

            } else {
                $("#EmailContainer").show();
                $("#EmailContainer").removeClass('d-none');
            }
        };

        //Run this function to hide everything that shouldnt be displayed
        UpdateNoEmailAddressInfo();

        $("#Email").change(function () {
            //If this is a new application 
            //We need to wait for the next button to be hidden
            if ($("#btnNext").is(":hidden")) {
                UpdateUserInfo();
            }
        });

        $("#btnNext").click(function (e) {
            //Cancel the click event
            e.preventDefault();
            e.stopImmediatePropagation();

            if ($("#Email").val() != "" || $("#IsNoEmailAddress").is(":checked")) {

                $("#emailValidationMessage").hide();

                //Display the common controls
                $('.displayEmailEntered').each(function () {
                    $(this).show().removeClass('d-none');
                });

                $('.displayNoEmailEntered').each(function () {
                    $(this).hide();
                });

                if ($("#IsNoEmailAddress").is(":checked")) {
                    UpdateNoEmailAddressInfo();
                } else {
                    //Update the user information based on email address
                    UpdateUserInfo();
                }
            } else {
                //display a validation message
                $("#emailValidationMessage").show().removeClass('d-none');
            }
        });

        function SetDisplayhasExistingWEAccount(isDisabled) {
            console.log('SetDisplayhasExistingWEAccount');
            if (isDisabled) {
                $('.displayhasExistingWEAccount').each(function () {
                    $(this).hide();
                });
            }
            else {
                $('.displayhasExistingWEAccount').each(function () {
                    $(this).show().removeClass('d-none');
                });
            }

        };

        function SetDisplayIamUserExists(isDisabled) {
            console.log('SetDisplayIamUserExists');

            if (isDisabled) {
                $('.displayIamUserExists').each(function () {
                    $(this).hide();
                });
            }
            else {
                $('.displayIamUserExists').each(function () {
                    $(this).show().removeClass('d-none');
                });
            }
        };

        function SetDisplayIamUserExistsHide(isDisabled) {
            console.log('SetDisplayIamUserExistsHide');
            if (isDisabled) {
                $('.displayIamUserExistsHide').each(function () {
                    $(this).hide();
                });
            }
            else {
                $('.displayIamUserExistsHide').each(function () {
                    $(this).show().removeClass('d-none');
                });
            }
        };

        function UpdateUserInfo() {

            if ($("#Email").val() == "" || !$("#Email").is(":valid")) {
                $("#FirstName").prop("readonly", false);
                $("#LastName").prop("readonly", false);
                $("#EmailAssociatedFormMessage").hide();
                $("#IamUserExists").hide();
                //$("#SubmitButton").prop("disabled", false);
                //$("#SaveDraftButton").prop("disabled", false);
                return;
            }

            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/wageenhancement/employeedetails/CheckEmployeeApplicationByEmail/' + oper + '/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/wageenhancement/employeedetails/CheckEmployeeApplicationByEmail/' + oper + '/';
            }
            $.ajax({
                url: url + '?email=' + $("#Email").val().replace("+", "%2B"),
                method: 'POST',
                contentType: false,
                processData: false,
                success: function (res) {
                    $("#FirstName").prop("readonly", false);
                    $("#LastName").prop("readonly", false);
                    $("#EmailAssociatedFormMessage").hide();
                    $("#IamUserExists").hide();
                    //$("#SubmitButton").prop("disabled", false);
                    //$("#SaveDraftButton").prop("disabled", false);

                    if (res == null) {
                        //Clear out these values
                        $("#FirstName").val('');
                        $("#LastName").val('');
                        DisplaySections(false, false);
                        return;
                    }

                    $("#FirstName").prop("readonly", true);
                    $("#FirstName").val(res.firstName);
                    $("#LastName").prop("readonly", true);
                    $("#LastName").val(res.lastName);

                    if (res.hasExistingWEAccount) {
                        DisplaySections(true, false);
                    } else {
                        DisplaySections(false, true);
                    }
                }
            });
        };

        function DisplaySections(hasExistingWEAccountbool, IamUserExistsbool) {

            //set the global values
            jsHasExistingWEAccount = hasExistingWEAccountbool;
            jsIamUserExists = IamUserExistsbool;

            if (hasExistingWEAccountbool == false && IamUserExistsbool == false) {
                //TODO: variables below need more comments to express what is the business case involved to show or hide html
                SetDisplayhasExistingWEAccount(false);
                SetDisplayIamUserExists(false);
                SetDisplayIamUserExistsHide(false);
            };

            if (hasExistingWEAccountbool == true && IamUserExistsbool == false) {
                $("#EmailAssociatedFormMessage").show().removeClass('d-none');
                 //TODO: variables below need more comments to express what is the business case involved to show or hide html
                SetDisplayIamUserExists(false);
                SetDisplayIamUserExistsHide(true);
                SetDisplayhasExistingWEAccount(true);                
            };

            if (hasExistingWEAccountbool == false && IamUserExistsbool == true) {
                $("#IamUserExists").show().removeClass('d-none');
                 //TODO: variables below need more comments to express what is the business case involved to show or hide html
                SetDisplayIamUserExists(false);
                SetDisplayIamUserExistsHide(true);
                SetDisplayhasExistingWEAccount(false);   
            };
        };

        $("#HourlyWageStr").change(function () {
            $("#HourlyWageVal").hide();

            // dont disable, if you do, use removeProp and removeAttr, replace with server side validation

            if ($(this).val().trim() == "") {
                return;
            }

            var regex;
            if (jsLang == "en") {
                regex = /^\d+[.]{0,1}\d{0,2}$/;
            } else {
                regex = /^\d+[,]{0,1}\d{0,2}$/;
            }
            if (!regex.exec($(this).val().replace("$", ""))) {
                $("#HourlyWageVal").html(jsHourlyWageInvalid);
                $("#HourlyWageVal").show();

            }
        })

        $("input[name='CanClaim05Hours']").change(function () {
            var val = $("input[name='CanClaim05Hours']:checked").val();

            if (val == jsTrueString) {
                $("#TrainingCompletedTypeDiv").removeClass("d-none")
            } else {
                $("#TrainingCompletedTypeDiv").addClass("d-none")
            }
        });

        $("input[name='CanClaim05Hours']").first().change();

        $("#RequestedFundingLevelTypeCd").change(function () {
            $(".funding-level-section").addClass("d-none");

            var id = $(this).val();

            var options = $("option.funding-level-option");;

            var optionCount = 0;
            var firstOption = -1;

            // Hide all the step options not available for the current funding level.
            options.each(function () {
                if ($(this).val() == jsOtherCd) {
                    return;
                }

                if ($(this).attr("data-type") == id) {
                    $(this).removeClass("d-none");

                    // The first option we find will be selected by default
                    // if only one option is available.
                    if (firstOption < 0) {
                        firstOption = $(this).val();
                    }

                    optionCount++;
                } else {
                    $(this).addClass("d-none");
                }
            });

            // If there's more than one option available (Minus the blank) we don't show the dropdown.
            // The only option will be selected by default.
            if (optionCount > 1) {
                $("#RequestedFundingLevelId").val(jsOtherCd);
                $(".funding-level-section").removeClass("d-none");

                if (jsFundingLevelId != 0) {
                    $("#RequestedFundingLevelId").val(jsFundingLevelId);
                }
                
            } else {
                $("#RequestedFundingLevelId").val(firstOption);
            }
            console.log("ID = " + id);
            console.log("cd = " + jsEntryLevelCd);
            // If untrained relief staff is selected, we need to do update some parts of the screen
            if (id == jsOtherCd) {
                $(".trained-only").each(function () {
                    $(this).addClass("d-none");
                });
            } else if (id == jsUntrainedReliefStaffCd) {
                $(".rolecheckbox").each(function () {
                    if ($(this).val() == jsEducatorRoleTypeCd) {
                        $(this).prop('checked', true);
                    } else {
                        $(this).prop('disabled', true);
                        $(this).prop('checked', false);
                    }
                });

                $(".trained-only").each(function () {
                    $(this).addClass("d-none");
                });
            } else {
                $(".rolecheckbox").each(function () {
                    $(this).prop('disabled', false);
                });

                $(".trained-only").each(function () {
                    $(this).removeClass("d-none");
                });

                $("input[name='CanClaim05Hours']").first().change();

                console.log("ID = " + id);
                console.log("cd = " + jsEntryLevelCd);

                if (id == jsEntryLevelCd) {
                    $(".hours-span").text(90);
                } else {
                    $(".hours-span").text(30);
                }
            }
        });

        $("#RequestedFundingLevelTypeCd").change();

        //$("#DateOfBirth").on("blur", CheckEmployeeByName);
        $("#OtherUserExists").hide();
        $("#BoolOtherUserExists").val(false);
        $(".employee-name-check").first().change();

        $(".licensecheckbox").on('change', function () {
            HandleRoleSelectionOnClicks($(this));
        });

        if (jsAllLicenseSelected) {
            $(".chk-0").prop('checked', true);
        }

        OperatorVisibility();

        function OperatorVisibility() {

            if ($(".home-based-facility:checked").length > 0) {
                $(".operator-role").each(function () {
                    $(this).show();
                });
            } else {
                $(".operator-role").each(function () {
                    $(this).children("input").prop("checked", false);
                    $(this).hide();
                });
            }
        }

        function HandleRoleSelectionOnClicks(self) {
            //number of checked checkboxes
            var noChecked = self.parent().parent().find('.custom-control-input:checked').length;

            //number of all checkboxes
            var noCheckBoxes = self.parent().parent().find('.custom-control-input').length;

            //check all option is now selected
            if (self.siblings(".custom-control-inputvalue").val() == "0") {
                var chkdStatus = self.is(":checked");
                $('.licensecheckbox').prop('checked', chkdStatus);
            }
            else {

                var me = 0;
                if (self.is(":checked")) { me = 1; }

                if (noChecked == 0) {
                    //all are not checked without using all option
                }
                else if (noChecked > 0 && noChecked == noCheckBoxes - me) {
                    //all are checked without using all option
                    $(".chk-0").prop('checked', true);
                }
                else if ($(".chk-0").length == 0 && noChecked == 1 && noChecked == 1) {
                    //only one item so  all option doesn't exist
                }
                else if (noChecked > 0 && noChecked != noCheckBoxes - me) {
                    //one or more licence checked but bnot all of them-for sure without using all option
                    $(".chk-0").prop('checked', false);
                }
            }

            OperatorVisibility();
        }

        $("#SubmitButton").click(function () {
            window.onbeforeunload = null;
            $("#IsSaveDraft").val(false);
            $("#IsDelete").val(false);
            return true;
        });

        $("#SaveDraftButton").click(function () {
            window.onbeforeunload = null;
            $("#IsSaveDraft").val(true);
            $("#IsDelete").val(false);
            return true;
        });

        $("#DeleteButton").click(function () {
            window.onbeforeunload = null;
            $("#IsDelete").val(true);
            return true;
        });

        function InitializeForm() {
            //Is this a new application?
            if (jsIsNew && jsEmailAddress.length == 0 && modelStateIsValid) {

                $('.displayNoEmailEntered').each(function () {
                    $(this).show();
                });

                //Display these button
                $("#btnNext").show().removeClass('d-none');
                $("#DeleteButton").show().removeClass('d-none');

            }
            else {
                //Determine the sections to display
                DisplaySections(jsHasExistingWEAccount, jsIamUserExists);

                //Hide the next button
                $("#btnNext").hide();

                //Display these button
                $("#SubmitButton").show().removeClass('d-none');
                //$("#SaveDraftButton").show().removeClass('d-none');
                $("#DeleteButton").show().removeClass('d-none');
                $(".displayConfirmation").show().removeClass('d-none');
                $(".displayFullname").show().removeClass('d-none');
            }
        }
        InitializeForm();

    } // if ($('form#EmploymentRecordDetailsForm').length > 0)
}); // $(function () {